import { StepChangeEvent, StepType, ValidationResult } from "../../types/types";
import { AddonParams, BaseAddon } from "../base/BaseAddon";
import { EntityRelationMetadata } from "./EntityRelationsManager";

export interface EntityRelationAddonConstructor {
  new(
    onNext: (event: StepChangeEvent) => void,
    onBack: () => void,
    params: AddonParams
  ): EntityRelationAddon;
}

export abstract class EntityRelationAddon extends BaseAddon {
  entityType: string;
  metadata: EntityRelationMetadata;

  constructor(
    name: string,
    entityType: string,
    metadata: EntityRelationMetadata,
    onNext: (event: StepChangeEvent) => void,
    onBack: () => void,
    params: AddonParams
  ) {
    super(name, [StepType.entityRelationValidation], onNext, params);
    this.entityType = entityType;
    this.metadata = metadata;
  }

  abstract getExistingEntities(): Promise<any[]>;
  abstract mapEntities(uploadedEntities: any[], existingEntities: any[]): Promise<any[]>;
  abstract validateEntities(mappedEntities: any[]): ValidationResult;

  abstract validateMappingResult(result: any): ValidationResult;
}
